var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5647 28.125C22.8134 28.125 28.6897 22.2487 28.6897 15C28.6897 7.75126 22.8134 1.875 15.5647 1.875C8.31596 1.875 2.4397 7.75126 2.4397 15C2.4397 22.2487 8.31596 28.125 15.5647 28.125Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1897 9.125L13.6897 17.625L10.1897 14.125L8.4397 15.875L13.6897 21.125L23.9397 10.875L22.1897 9.125Z",
    fill: "#CCFF90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.6ce486ee1ad2bc7b13d583789f042fdd.svg";
export { ForwardRef as ReactComponent };